import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { JobSummary } from '../../models/job-summary';
import { JobsStore } from '../../store/jobs-store.service';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-latest-jobs',
  templateUrl: './latest-jobs.component.html',
  styleUrls: ['./latest-jobs.component.scss']
})
export class LatestJobsComponent implements OnInit, OnDestroy {
  latestJobs: JobSummary[];
  subscription: Subscription;
  currentRoute: string;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  }
  
  constructor(private jobStore: JobsStore,
    public route: ActivatedRoute) { 
    this.currentRoute = this.route.snapshot.url[0].path;
  }

  ngOnInit() {
    this.subscription = this.jobStore.latestJobs.subscribe(resp => {
      this.latestJobs = resp;
    });
  }

  onFavouriteClicked(jobId: string): void {
    const foundJob = this.latestJobs.find(job => job.id == jobId);
    if(!foundJob) {
      throw new Error(`Job not found for Id ${jobId}`);
    }

    foundJob.bookmarked = !foundJob.bookmarked;
    if(foundJob.bookmarked) {
      this.jobStore.bookmarkJobInLocalStore(foundJob.id);
    } else {
      this.jobStore.unBookmarkJobInLocalStore(foundJob.id);
    }
  }

  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe(); 
    }
  }

}
